import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { error, failedResponse, getBackendUrl, loaded, loading, LoadState, LoadStateInfo, notStarted } from "../../common";

export interface MassiveMessageUser {
	id: number,
	massiveMessageId: number,
	conversationMessageId: number,
	studentId: number,
	userId: number,
}

export interface MassiveMessageUserRequest {
    massiveMessageId?: number;
}

export const retrieveMassiveMessageUsers = createAsyncThunk(
    "retrieveMassiveMessageUserss",
    async (param: MassiveMessageUserRequest, thunkAPI) => {
        console.debug("retrieve massive message users");

        const token = (thunkAPI.getState() as RootState).user.token;

        const response = await fetch(`${getBackendUrl()}/api/conversation/massive/message/users/${param.massiveMessageId}`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param, { getState }) => {
            const state = getState() as RootState;
            if(! state.user.token) {
                console.debug("No token, not loading massive message users list");
                return false;
            }
            if (state.massiveMessageUser.state.state === LoadState.NotStarted) {
                // Only load if never loaded before
                return true; 
            }
            return false;
        },
    }
);

export interface MassiveMessageUserState {
    state: LoadStateInfo;
    request?: MassiveMessageUserRequest;
    list?: MassiveMessageUser[];
}

const initialState: MassiveMessageUserState = {
    state: notStarted(),
};

export const massiveMessageUserSlice = createSlice({
    name: "massiveMessageUser",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
            state.list = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveMassiveMessageUsers.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
                state.list = undefined;
            })
            .addCase(retrieveMassiveMessageUsers.fulfilled, (state, action) => {
                state.state = loaded();
                // ensure deterministic order: sort by studentId, then by userId
                const list = (action.payload || []).slice();
                list.sort((a: MassiveMessageUser, b: MassiveMessageUser) => {
                    const sa = a.studentId || 0;
                    const sb = b.studentId || 0;
                    if (sa !== sb) return sa - sb;
                    const ua = a.userId || 0;
                    const ub = b.userId || 0;
                    return ua - ub;
                });
                state.list = list;
            })
            .addCase(retrieveMassiveMessageUsers.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

// export const { } = conversationListSlice.actions;

export const selectMassiveMessageUser = (state: RootState) => state.massiveMessageUser;

export default massiveMessageUserSlice.reducer;
